import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/esm/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _createSuper from "@babel/runtime/helpers/esm/createSuper";
import React, { Component, useState } from 'react';
import uniqueId from 'lodash.uniqueid';
import { ErrorMessage } from 'formik';
import { Form, MenuItem } from 'react-bootstrap';
import { IoIosCloseCircle } from 'react-icons/io';
import { asyncContainer, Typeahead, Menu, menuItemContainer } from 'react-bootstrap-typeahead';
import { RichText } from '@sitecore-jss/sitecore-jss-react';
var AsyncTypeahead = asyncContainer(Typeahead); // Global Form Methods

import FormMethods from './Methods'; // Input masks

import { masks } from '../util/masks';

var FormInputAhead = /*#__PURE__*/function (_Component) {
  _inherits(FormInputAhead, _Component);

  var _super = _createSuper(FormInputAhead);

  function FormInputAhead(props) {
    var _this;

    _classCallCheck(this, FormInputAhead);

    _this = _super.call(this, props);
    _this.handleFocus = FormMethods.handleFocus.bind(_assertThisInitialized(_this));
    _this.handleBlur = FormMethods.handleBlur.bind(_assertThisInitialized(_this));
    _this.state = {
      name: props.field.name
    };
    _this.id = uniqueId();
    return _this;
  }

  _createClass(FormInputAhead, [{
    key: "componentWillReceiveProps",
    value: function componentWillReceiveProps(newProps) {
      if (newProps.results !== this.props.results) {
        this.setState({
          results: newProps.results
        });
      }
    }
  }, {
    key: "onChange",
    value: function onChange(e) {
      this.props.changeHandler(e);
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props = this.props,
          _this$props$field = _this$props.field,
          name = _this$props$field.name,
          field = _objectWithoutProperties(_this$props$field, ["name"]),
          props = _objectWithoutProperties(_this$props, ["field"]);

      var errors = this.props.form.errors;
      var touched = this.props.form.touched;
      var Tag = AsyncTypeahead;
      return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Form.Group, {
        controlId: "".concat(this.props.field.name, "-").concat(this.id),
        onBlur: this.handleBlur,
        className: "cb-bg-color-white"
      }, /*#__PURE__*/React.createElement(Form.Label, {
        className: "\n            cb-form__label\n            ".concat(this.props.className, "\n            ").concat(this.state.active ? 'is-active' : '', "\n            ").concat(typeof field.value !== 'undefined' && field.value !== '' ? 'is-filled' : '', "\n          ")
      }, this.props.label || name), /*#__PURE__*/React.createElement(Tag, {
        className: "\n              ".concat(this.props.className, "\n              ").concat(typeof field.value !== 'undefined' && field.value !== '' ? 'is-filled' : '', "\n              ").concat(errors[this.props.field.name] && touched[this.props.field.name] ? 'is-error' : '', "\n            "),
        id: "".concat(this.props.field.name, "-").concat(this.id),
        name: this.props.field.name,
        type: this.props.type,
        placeholder: this.props.placeholder,
        value: this.state.value,
        autoComplete: this.props.autocomplete,
        onBlur: field.onBlur,
        onFocus: this.handleFocus,
        onError: field.handleError,
        options: this.props.results,
        isLoading: false,
        labelKey: "Title",
        minLength: 3,
        maxResults: 5,
        useCache: true,
        submitFormOnEnter: true,
        onChange: function onChange(e) {
          var element = e[0];

          if (element.PageUrl) {
            return window.location.href = element.PageUrl;
          }

          return window.location.href = "/search?query=".concat(e.Title);
        },
        onKeyDown: function onKeyDown(e) {
          if (e.keyCode === 13) {
            return window.location.href = "/search?query=".concat(e.target.value);
          }
        },
        onSearch: function onSearch(query) {
          return _this2.onChange(query);
        }
      }), /*#__PURE__*/React.createElement(ErrorMessage, {
        name: name
      }, function (msg) {
        return /*#__PURE__*/React.createElement("div", {
          className: "cb-form__error-message"
        }, /*#__PURE__*/React.createElement(IoIosCloseCircle, null), " ", msg);
      })));
    }
  }]);

  return FormInputAhead;
}(Component);

FormInputAhead.defaultProps = {
  type: "text",
  value: "",
  className: "",
  placeholder: ""
};
export default FormInputAhead;